import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
    root: {

        backgroundColor: theme.palette.primary.main,
        "@media(max-width: 770px)": {
            display: "none"
        }

    },

    marginStyle: {
        //  marginLeft: "10%"
    },

    tabStyle: {
        fontSize: "18px",
        fontWeight: 600,
        color: "#fff"
    }
}))


const Menu = () => {

    const [value, setValue] = useState(1);

    let history = useHistory();


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const style = useStyles();

    return (
        <Tabs value={value} className={style.root} onChange={handleChange} indicatorColor="primary" textColor="secondary" >
            <Tab className={style.marginStyle} />
            <Tab className={style.tabStyle} label="Home" onClick={(e) => history.push("/")} />
            <Tab className={style.tabStyle} label="리서치" onClick={(e) => history.push("/post")} />
            <Tab className={style.tabStyle} label="리서치 작성" onClick={(e) => history.push("/write/post")} />
            <Tab className={style.tabStyle} label="투표" onClick={(e) => history.push("/general")} />
            <Tab className={style.tabStyle} label="투표 작성" onClick={(e) => history.push("/write/general")} />
            <Tab className={style.tabStyle} label="About SurBay" onClick={(e) => history.push("/about")} />
            <Tab className={style.tabStyle} label="Tip" onClick={(e) => history.push("/tip")} />
            <Tab className={style.tabStyle} label="콘텐츠" onClick={(e) => history.push("/content")} />
        </Tabs>
    );
};

export default Menu;